import { FlowSplit } from '@pe/checkout/types';

export class SetSplits {
  static readonly type = '[Split] Set split payments';
  constructor(public payload: FlowSplit[]) {}
}
export class SubmitSplitFlow {
  static readonly type = '[Split] Submit split flow';
}
